import SC from "./style";
import { useEffect, useState } from "react";
import { Button } from "InnoUI/components";
import theme from "theme";
import BulkActionView from "InnoUI/components/BulkActionView";
import { Notificationdropdown, InputField } from "components";
import { apiPost } from "api/callApi";
import { useSearchParams } from "react-router-dom";
import { showAlert } from "utils/helper";

function JournalSendHistory(props) {
  const {
    setOpenModalView,
    openModalView,
    journalId,
    onClose,
    JournalProjectId,
    JournalProjectType,
  } = props;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    journalId: journalId,
  });
  const [searchParams] = useSearchParams();
  const projectId = searchParams.get("projectId") || JournalProjectId;
  const type = searchParams.get("type") || JournalProjectType;

  const handleChange = (property, value) => {
    setData((prevData) => ({
      ...prevData,
      [property]: value,
    }));
  };

  // Handle form submission for Add or Edit
  const handleSubmit = async () => {
    try {
      setLoading(true);
      const response = await apiPost(`/v1/journal/sendhistoryjournal`, data);
      showAlert({
        title: "Success",
        text: response.message,
        icon: "success",
      });
      setOpenModalView(false);
      setData("");
      setLoading(false);
      if (!JournalProjectId) {
        onClose();
      }
    } catch (error) {
      showAlert({
        title: "Error",
        text: error.response.data.message,
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCancelCompanyModal = () => {
    setOpenModalView(false);
    setData({});
  };

  const AddCompanyModalData = () => {
    return (
      <div>
        <div style={{ marginTop: "30px" }}>
          <SC.LabelContainer>
            <SC.Label>To</SC.Label>
            <SC.Children>
              <SC.Wrapper>
                <Notificationdropdown
                  defaultValue={data?.sendTo || ""}
                  name="sendTo"
                  onChange={handleChange}
                  projectId={projectId}
                  type={type}
                  width="100%"
                  disabledValues={data?.users}
                  maxTagCount={8}
                />
              </SC.Wrapper>
            </SC.Children>
          </SC.LabelContainer>
          {/* Alarm Recipient(s) */}
          <SC.LabelContainer>
            <SC.Label>Cc</SC.Label>
            <SC.Children>
              <SC.Wrapper>
                <Notificationdropdown
                  defaultValue={data?.sendCc || ""}
                  name="sendCc"
                  onChange={handleChange}
                  projectId={projectId}
                  type={type}
                  width="100%"
                  maxTagCount={8}
                />
              </SC.Wrapper>
            </SC.Children>
          </SC.LabelContainer>
          {/* Alarm Recipient(s) */}
          <SC.LabelContainer>
            <SC.Label>Bcc</SC.Label>
            <SC.Children>
              <SC.Wrapper>
                <Notificationdropdown
                  defaultValue={data?.sendBcc || ""}
                  name="sendBcc"
                  onChange={handleChange}
                  projectId={projectId}
                  type={type}
                  width="100%"
                  maxTagCount={8}
                />
              </SC.Wrapper>
            </SC.Children>
          </SC.LabelContainer>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            margin: "35px 20px 20px 20px",
          }}
        >
          <Button
            caption="Cancel"
            onClick={handleCancelCompanyModal}
            fontSize="12px"
            style={{
              marginBottom: 8,
              background: theme.colors.cancelButton,
              color: theme.colors.white,
              minWidth: "90px",
              borderRadius: "3px",
              height: "30px",
              fontSize: "12px",
            }}
            disabled={loading}
          />

          <Button
            caption={loading ? "Sending..." : "Send"}
            isLoading={loading}
            onClick={handleSubmit}
            color="white"
            fontSize="12px"
            style={{
              marginBottom: 8,
              background: theme.gradient.themeGradient,
              color: theme.colors.white,
              minWidth: "90px",
              height: "30px",
              borderRadius: "3px",
            }}
            disabled={loading}
          />
        </div>
      </div>
    );
  };

  return (
    <>
      {openModalView && (
        <BulkActionView
          title={"Journal Send"}
          openModal={openModalView}
          renderBodyConditionally={AddCompanyModalData}
          handleCloseModal={() => {
            setOpenModalView(false);
            setData("");
          }}
        />
      )}
    </>
  );
}

export default JournalSendHistory;
